import { TeamService } from '@modules/team/team-service';
import { SubprogramService } from '@modules/subprogram/subprogram-service';
import { ProgramService } from '@modules/program/program-service';
import Errors from '@shared/error/errors';

export default {
  namespaced: true,

  state: {
    subprogram: null,
    program: null,
    team: null,
    loading: false,
  },

  getters: {
    subprogram: (state) => state.subprogram,
    program: (state) => state.program,
    team: state => state.team,
    loading: state => state.loading,
  },

  mutations: {
    LOAD_STARTED(state) {
      state.program = null;
      state.subprogram = null;
      state.team = {};
      state.loading = true;
    },
    LOAD_SUCCESS(state, { program, subprogram, team }) {
      state.program = program;
      state.subprogram = subprogram;
      state.team = team;
      state.loading = false;
    },
    LOAD_ERROR(state) {
      state.program = null;
      state.subprogram = null;
      state.team = {};
      state.loading = false;
    }
  },

  actions: {
    async doLoad({commit}, { subpropertyId,  programId, subprogramId, teamId }) {
      try {
        commit('LOAD_STARTED');

        const manageInput = {
          type: 'subproperty',
          subpropertyId,
          programId,
        };

        const p1 = new Promise((resolver) => resolver(ProgramService.find(
          programId,
          manageInput,
        ))); 
        
        const p2 = new Promise((resolver) => resolver(SubprogramService.find(
          subprogramId,
          manageInput,
        ))); 
  
        const p3 = new Promise((resolver) => resolver(TeamService.find(
          teamId, manageInput
        ))); 
        
        Promise.all([p1, p2, p3]).then(values => { 
          const program = values[0];
          const subprogram = values[1];
          const team = values[2];
          
          commit('LOAD_SUCCESS', { program, subprogram, team});
        });
        
      } catch (error) {
        Errors.handle(error);
        commit('LOAD_ERROR');
      }
    }
  }
};